import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAgentColors, getAgentColorDetails, getAgentColorThemes, updateAgentColors } from "../../actions/agent-colour.action";
import { agentColorDetailsSelector, agentColorThemesSelector } from "../../selector/agent-colour.selector";
import { Form, Input, Button , Row, Col, Select } from 'antd';
import '../../styles/colour-config-page.style.scss';

const mapThemeToFormValues = (theme) => ({
    primaryColor: theme.primary_color,
    secondaryColor: theme.secondary_color,
    defaultButtonBgColor: theme.default_button_bg_color,
    defaultButtonTxtColor: theme.default_button_txt_color,
    headerBgColor: theme.header_bg_color,
    headerTxtColor: theme.header_txt_color,
    dropDownMenuBgColor: theme.drop_down_menu_bg_color,
    dropDownMenuTxtColor: theme.drop_down_menu_txt_color,
    dropDownSelectedBgColor: theme.drop_down_selected_bg_color,
    dropDownSelectedTxtColor: theme.drop_down_selected_txt_color,
    officebookedmale: theme.officebookedmale,
    officebookedfemale: theme.officebookedfemale,
    selfbookedmale: theme.selfbookedmale,
    selfbookedfemale: theme.selfbookedfemale,
    agentbookedmale: theme.agentbookedmale,
    agentbookedfemale: theme.agentbookedfemale,
    otabookedmale: theme.otabookedmale,
    otabookedfemale: theme.otabookedfemale,
    officeblockedmale: theme.officeblockedmale,
    officeblockedfemale: theme.officeblockedfemale,
    selfblockedmale: theme.selfblockedmale,
    selfblockedfemale: theme.selfblockedfemale,
    agentblockedmale: theme.agentblockedmale,
    agentblockedfemale: theme.agentblockedfemale,
    otablockedmale: theme.otablockedmale,
    otablockedfemale: theme.otablockedfemale,
    adminblockedself: theme.adminblockedself,
    adminblockedothers: theme.adminblockedothers,
    phoneblockedgeneral: theme.phoneblockedgeneral,
    selectedseat: theme.selectedseat,
    vacantseat: theme.vacantseat,
    websitebookedmale: theme.websitebookedmale,
    websitebookedfemale: theme.websitebookedfemale
});

export const ColourConfigPage = () => {
    const dispatch = useDispatch();
    const agentColorDetails = useSelector(agentColorDetailsSelector);
    const agentColorThemes = useSelector(agentColorThemesSelector);
    const [form] = Form.useForm();

    useEffect(() => {
        dispatch(getAgentColorDetails(global.operatorCode));
        dispatch(getAgentColorThemes());
    }, [dispatch]);

    const onThemeSelect = (themeId) => {
        const theme = agentColorThemes.find(item => item.id === themeId);
        if (theme) {
            form.setFieldsValue(mapThemeToFormValues(theme));
        }
    };

    useEffect(() => {
        if (agentColorDetails) {
            const {
                operator_code,
                primary_color,
                secondary_color,
                default_button_bg_color,
                default_button_txt_color,
                header_bg_color,
                header_txt_color,
                drop_down_menu_bg_color,
                drop_down_menu_txt_color,
                drop_down_selected_bg_color,
                drop_down_selected_txt_color,
                officebookedmale,
                officebookedfemale,
                selfbookedmale,
                selfbookedfemale,
                agentbookedmale,
                agentbookedfemale,
                otabookedmale,
                otabookedfemale,
                officeblockedmale,
                officeblockedfemale,    
                selfblockedmale,
                selfblockedfemale,
                agentblockedmale,
                agentblockedfemale,
                otablockedmale,
                otablockedfemale,
                adminblockedself,
                adminblockedothers,
                phoneblockedgeneral,
                selectedseat,
                vacantseat,
                websitebookedfemale,
                websitebookedmale
            } = agentColorDetails;

            form.setFieldsValue({
                operatorCode: operator_code,
                primaryColor: primary_color,
                secondaryColor: secondary_color,
                defaultButtonBgColor: default_button_bg_color,
                defaultButtonTxtColor: default_button_txt_color,
                headerBgColor: header_bg_color,
                headerTxtColor: header_txt_color,
                dropDownMenuBgColor: drop_down_menu_bg_color,
                dropDownMenuTxtColor: drop_down_menu_txt_color,
                dropDownSelectedBgColor: drop_down_selected_bg_color,
                dropDownSelectedTxtColor: drop_down_selected_txt_color,
                officebookedmale: officebookedmale,
                officebookedfemale: officebookedfemale,
                selfbookedmale: selfbookedmale,
                selfbookedfemale: selfbookedfemale,
                agentbookedmale: agentbookedmale,
                agentbookedfemale: agentbookedfemale,
                otabookedmale: otabookedmale,
                otabookedfemale: otabookedfemale,
                officeblockedmale: officeblockedmale,
                officeblockedfemale: officeblockedfemale,   
                selfblockedmale: selfblockedmale,
                selfblockedfemale: selfblockedfemale,
                agentblockedmale: agentblockedmale,
                agentblockedfemale: agentblockedfemale,
                otablockedmale: otablockedmale,
                otablockedfemale: otablockedfemale, 
                adminblockedself: adminblockedself,
                adminblockedothers: adminblockedothers,
                phoneblockedgeneral: phoneblockedgeneral,
                selectedseat: selectedseat,
                vacantseat:vacantseat,
                websitebookedfemale:websitebookedfemale,
                websitebookedmale:websitebookedmale
            });
        }
    }, [agentColorDetails, form]);

    const onFinish = (values) => {
        const { operatorCode, ...colorData } = values;
        if(operatorCode == "DEFAULT") {
            dispatch(createAgentColors(
                global.operatorCode, 
                colorData,
                () => {},
                () => {},
            ));
        } else {
            dispatch(updateAgentColors(
                global.operatorCode, 
                colorData,
                () => {},
                () => {},
            ));
        }
    };

    return (
        <div className="colour-config-page">
            <Row justify="center" align="middle" style={{ paddingTop: 24, marginBottom: 24 }}>
                <span style={{ marginRight: 8, fontWeight: 500 }}>Theme :</span>
                <Select
                    style={{ width: 240 }}
                    placeholder="Select a theme"
                    allowClear
                    onChange={onThemeSelect}
                    options={agentColorThemes.map(theme => ({
                        value: theme.id,
                        label: theme.theme_name
                    }))}
                />
            </Row>
            <Form
                form={form}
                onFinish={onFinish}
                name="colorConfig"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 4 }}
                initialValues={{ operatorCode: global.operatorCode }}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        {[
                            { label: "Primary color", name: "primaryColor" },
                            { label: "Secondary color", name: "secondaryColor" },
                            { label: "Default button bg color", name: "defaultButtonBgColor" },
                            { label: "Default button text color", name: "defaultButtonTxtColor" },
                            { label: "Header bg color", name: "headerBgColor" },
                            { label: "Header text color", name: "headerTxtColor" },
                            { label: "Drop down menu bg color", name: "dropDownMenuBgColor" },
                            { label: "Drop down menu text color", name: "dropDownMenuTxtColor" },
                            { label: "Drop down selected bg color", name: "dropDownSelectedBgColor" },
                            { label: "Drop down selected text color", name: "dropDownSelectedTxtColor" }
                        ].map(({ label, name }) => (
                            <Form.Item
                                key={name}
                                label={label}
                                name={name}
                                rules={[{ required: true, message: `Please select the ${label.toLowerCase()}!` }]}
                            >
                                <Input 
                                    type="color"
                                />
                            </Form.Item>
                        ))}
                    </Col>
                    <Col span={12}>
                    {[
                            { label: "Office booked male", name: "officebookedmale" },
                            { label: "Office booked female", name: "officebookedfemale" },
                            { label: "Self booked male", name: "selfbookedmale" },
                            { label: "Self booked female", name: "selfbookedfemale" },
                            { label: "Agent booked male", name: "agentbookedmale" },
                            { label: "Agent booked female", name: "agentbookedfemale" },
                            { label: "OTA booked male", name: "otabookedmale" },
                            { label: "OTA booked female", name: "otabookedfemale" },
                            { label: "Office blocked male", name: "officeblockedmale" },
                            { label: "Office blocked female", name: "officeblockedfemale" },
                            { label: "Self blocked male", name: "selfblockedmale" },
                            { label: "Self blocked female", name: "selfblockedfemale" },
                            { label: "Agent blocked male", name: "agentblockedmale" },
                            { label: "Agent blocked female", name: "agentblockedfemale" },
                            { label: "OTA blocked male", name: "otablockedmale" },
                            { label: "OTA blocked female", name: "otablockedfemale" },
                            { label: "Admin blocked self", name: "adminblockedself" },
                            { label: "Admin blocked others", name: "adminblockedothers" },
                            { label: "Phone blocked general", name: "phoneblockedgeneral" },
                            { label: "Website booked male", name: "websitebookedmale" },
                            { label: "Website booked female", name: "websitebookedfemale" },
                            { label: "Selected seat", name: "selectedseat" },
                            { label:"Vacant seat", name:"vacantseat"}
                        ].map(({ label, name }) => (
                            <Form.Item
                                key={name}
                                label={label}
                                name={name}
                                rules={[{ required: false, message: `Please select the ${label.toLowerCase()}!` }]}
                            >
                                <Input 
                                    type="color"
                                />
                            </Form.Item>
                        ))}
                    </Col>

                </Row>


                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        Update Colors
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};


